import { render } from "./Invite.vue?vue&type=template&id=3fec6337"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Invite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fec6337"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fec6337', __exports__)) {
    api.reload('3fec6337', __exports__)
  }
  
  module.hot.accept("./Invite.vue?vue&type=template&id=3fec6337", () => {
    api.rerender('3fec6337', render)
  })

}


export default __exports__